import type { IntegrationRequestPayload } from '../../models/IntegrationRequest';
import { NotificationSeverity } from '@/components/notifications/Notification';
import { CommerceSelectPanel } from '../CommerceIntegration/components';
import { INTEGRATION_REQUESTS_PATH, apiErrorMessage } from './config';
import { useCreateIntegrationRequestMutation } from '../../services';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useIntegrationRequestBreadcrumbs, useIsIntegrationIt } from './hooks';
import { IntegrationRequestForm } from './components';
import { NavigateLinks } from '@/components';
import type { Commerce } from '../../models';
import { useNotification } from '@/hooks';
import { useState } from 'react';

const NewIntegrationRequestPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { showNotification } = useNotification();
  const [selectedCommerce, setSelectedCommerce] = useState<Commerce | null>(null);
  const [createRequest, { isLoading: isSaving }] = useCreateIntegrationRequestMutation();

  const commerceId = searchParams.get('commerceId') || selectedCommerce?.id || '';

  const breadcrumbs = useIntegrationRequestBreadcrumbs();
  const isIt = useIsIntegrationIt();

  const handleSubmit = async (payload: IntegrationRequestPayload) => {
    try {
      const created = await createRequest(payload).unwrap();
      showNotification(
        isIt ? 'Integración creada' : 'Solicitud enviada a TI',
        NotificationSeverity.success
      );
      navigate(`${INTEGRATION_REQUESTS_PATH}/${created.id}`);
    } catch (error) {
      showNotification(
        apiErrorMessage(error, 'No se pudo crear la solicitud'),
        NotificationSeverity.error
      );
    }
  };

  return (
    <section className='flex flex-col gap-6 w-full h-full'>
      <NavigateLinks
        actualPage={isIt ? 'Nueva integración' : 'Nueva solicitud de integración'}
        breadcrumbs={breadcrumbs}
      />

      {!searchParams.get('commerceId') && (
        <CommerceSelectPanel selected={selectedCommerce} onSelect={setSelectedCommerce} />
      )}

      {commerceId && (
        <IntegrationRequestForm
          key={commerceId}
          commerceId={commerceId}
          isSaving={isSaving}
          submitLabel={isIt ? 'Guardar e ir a integrar' : 'Enviar a TI'}
          onSubmit={handleSubmit}
          onCancel={() => navigate(INTEGRATION_REQUESTS_PATH)}
        />
      )}
    </section>
  );
};

export default NewIntegrationRequestPage;
